import { gql } from "@grandvisionhq/graphql";
import { availableShippingMethod } from "../../../fragments/operations/fragments/shipping-method.js";
const GET_SHIPPING_METHODS_FOR_CART = gql`
  query ShippingMethodsForCart($checkoutId: ID!) {
    shippingMethodsForCart(checkoutId: $checkoutId) {
      ...AvailableShippingMethodFragment
    }
  }
  ${availableShippingMethod}
`;
export {
  GET_SHIPPING_METHODS_FOR_CART
};
//# sourceMappingURL=get-shipping-methods-for-cart.js.map
